import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureTypeSettingsStepsViewTopBar } from "./TopBar"

export const procedureTypeSettingsStepsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureTypeSettingsStepsViewTopBar,
}
